// extracted by mini-css-extract-plugin
export default {"tooltipTitleStyles":"TooltipComponent_tooltipTitleStyles__ALB7r"};